const BASE = import.meta.env.VITE_API_BASE_URL || "http://localhost:3001";

export class ApiError extends Error {
  constructor(public status: number, public code: string, public details?: unknown) {
    super(`API ${status} ${code}`);
  }
}

export async function api<T = unknown>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    let body: { error?: string; details?: unknown } = {};
    try {
      body = await res.json();
    } catch {}
    throw new ApiError(res.status, body.error ?? "api_error", body.details);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
